import { useAIPanel } from "@/contexts/AIPanelContext";
import { Pin, X, FileText, User, AlertTriangle, CheckSquare, Lightbulb } from "lucide-react";

export function PinnedItemsBar() {
  const { pinnedItems, unpinItem, clearPinnedItems } = useAIPanel();

  if (!pinnedItems || pinnedItems.length === 0) return null;

  const getItemIcon = (type: string) => {
    switch (type) {
      case "processo":
        return <FileText className="w-3 h-3 text-blue-500" />;
      case "patente":
        return <Lightbulb className="w-3 h-3 text-indigo-500" />;
      case "cliente":
        return <User className="w-3 h-3 text-emerald-500" />;
      case "alerta":
        return <AlertTriangle className="w-3 h-3 text-amber-500" />;
      default:
        return <CheckSquare className="w-3 h-3 text-purple-500" />;
    }
  };

  return (
    <div className="border-t border-slate-200 bg-blue-50/50 px-3 py-2">
      <div className="flex items-center justify-between gap-2 mb-1.5">
        <div className="flex items-center gap-1.5 text-[10px] font-semibold text-blue-800">
          <Pin className="w-3 h-3 text-blue-600 fill-blue-500" />
          <span>Itens fixados na tela ({pinnedItems.length})</span>
        </div>
        <button
          type="button"
          onClick={clearPinnedItems}
          className="text-[10px] text-slate-500 hover:text-red-600 hover:underline transition-colors"
        >
          Limpar todos
        </button>
      </div>

      <div className="flex flex-wrap gap-1.5 max-h-24 overflow-y-auto">
        {pinnedItems.map((item) => (
          <div
            key={item.id}
            className="inline-flex items-center gap-1.5 rounded-md border border-blue-200 bg-white px-2 py-0.5 text-[11px] font-medium text-slate-700 shadow-2xs"
            title={`${item.title} ${item.subtitle ? `(${item.subtitle})` : ""}`}
          >
            {getItemIcon(item.type)}
            <span className="max-w-[130px] truncate font-semibold">
              {item.code || item.title}
            </span>
            <button
              type="button"
              onClick={() => unpinItem(item.id)}
              className="text-slate-400 hover:text-slate-700 p-0.5 rounded transition-colors"
              title="Desafixar item"
            >
              <X className="w-2.5 h-2.5" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
